export default __webpack_public_path__ + "static/media/The_King_Sejong_Station_LE.422b61fa.jpg";